// extracted by mini-css-extract-plugin
export default {"container":"UnitList_container__FhksD","iconFlex":"UnitList_iconFlex__Z28Kg","iconBox":"UnitList_iconBox__Der9e"};